<template>
   <div id="checkout-wrapper">
      <Aside />
      <Main>
         <Navbar />

         <div class="send-offer-mobile d-lg-none" @click="handlerDocumentViewer(2)">
            {{ $t("basketComponentFlight_sendOffer") }}
         </div>

         <!-- FlightCheckout Grid -->
         <div class="container-lg px-md-2 px-lg-0">
            <div class="col px-md-2 px-lg-0">
               <div class="row gx-4" :class="isPageLoad ? '' : 'data-mask'">
                  <div class="col-12 col-lg-10">
                     <!--Info Badge -->
                     <div class="checkout-badges">
                        <!-- <Badge2 :msg="$t('flightCheckout_BrandPriceUnavailable')" warning v-if="brandPriceUnavailable" /> -->
                        <Badge2 :msg="$t('flightCheckout_SELECTED_BRANDS_NOT_VALID_NOW')" warning v-if="handlerPaymentTypes" />
                        <!-- <Badge2 :msg="$t('flightCheckout_SELECTED_BRANDS_NOT_VALID_NOW')" warning v-if="handlerPaymentTypes" /> -->
                        <Badge2 :msg="$t('flightInformationsComponent_timeChanged')" error v-if="isChanged" />

                        <Badge2
                           v-for="warning in warningsV2Filtered"
                           :key="warning.id"
                           :msg="warning.message"
                           :warning="warning.badgeType === 'warning'"
                           :error="warning.badgeType === 'error'"
                           :info="warning.badgeType === 'info'" />
                     </div>
                     <!-- Mobile Pnr Information -->
                     <CheckoutPnrInfoBadge />

                     <!-- Flight Informations -->
                     <FlightInformations />

                     <!-- Price Informations -->
                     <PriceInformations />

                     <!-- Passenger Informations -->
                     <PassengerInformations />

                     <!-- Contact Informations -->
                     <CommonCheckoutContact :isflight="true" :isShowAutofill="true" :isBorderavailable="true" :isShowMail="true" />

                     <!-- Checkout Payment -->

                     <div class="checkout-payment-container gts-box pt-0">
                        <PaymentPurchaseWidget entityType="flight" :checkoutRequest="checkoutRequestModel" :paymentChoiceDetail="paymentChoiceDetail" />
                     </div>

                     <!-- Checkout Notes -->
                     <CheckoutNotes />
                  </div>
                  <div class="col d-none d-lg-block col-lg-2">
                     <!-- Flight Checkout -->
                     <CheckoutBasket />
                  </div>
               </div>
            </div>
         </div>
      </Main>
   </div>
</template>

<script>
// import router from "@/router/index.js";
import Aside from "@/components/unitary/Aside.vue";
import Navbar from "@/components/unitary/Navbar.vue";
import Main from "@/components/unitary/Main.vue";

import CheckoutPnrInfoBadge from "@/components/structural/flight/checkout/CheckoutPnrInfoBadge.vue";
import FlightInformations from "@/components/structural/flight/checkout/FlightInformations.vue";
import PriceInformations from "@/components/structural/flight/checkout/PriceInformations.vue";
import PassengerInformations from "@/components/structural/flight/checkout/PassengerInformations.vue";
import PaymentPurchaseWidget from "@/components/structural/payment/PaymentPurchaseWidget.vue";
import CheckoutNotes from "@/components/structural/flight/checkout/CheckoutNotes.vue";
import CheckoutBasket from "@/components/structural/flight/checkout/CheckoutBasket.vue";
import Badge2 from "@/components/unitary/Badge2.vue";
import { flightService } from "@/service/index.js";
import { generateUuid, getCookie, setCookie } from "@/utils.js";
import CommonCheckoutContact from "@/components/unitary/CommonCheckoutContact.vue";

// import response from "@/placeholders/orderDetail.js";

export default {
   name: "FlightCheckout",
   components: {
      Aside,
      Navbar,
      Main,
      CheckoutPnrInfoBadge,
      Badge2,
      FlightInformations,
      PriceInformations,
      PassengerInformations,
      CommonCheckoutContact,
      PaymentPurchaseWidget,
      CheckoutNotes,
      CheckoutBasket,
   },
   data() {
      return {
         isPageLoad: false,
         isChanged: false,
         brandPriceUnavailable: false,
         checkoutRequestModel: {},
         paymentChoiceDetail: {},
      };
   },
   created() {
      const self = this;

      generateUuid();

      // realData Query
      let query = {
         searchUuid: self.$route.params.uuid,
         trxType: 1,
         uuid: this.$route.query.uuid,
         checkoutUuid: self.$route.query.refresh ? self.$route.query.refresh : null,
         pnrId: self.$route.query.pnr ? self.$route.query.pnr : 0,
      };

      flightService.checkout(query).then((response) => {
         self.$store.commit("flight/updateCheckoutResponse", response.checkoutResponse);
         self.$store.commit("flight/updateCheckoutRequest", response.checkoutRequest);

         self.handlerCookieData(response.checkoutRequest.passengers);

         self.checkoutRequestModel = self.$store.state.flight.checkout.request;
         self.checkoutRequestModel.uuid = self.$route.query.uuid;
         self.paymentChoiceDetail = self.$store.state.flight.checkout.response.paymentChoiceDetail;
         if (!this.$route.query.refresh) {
            this.$router.push({ query: { refresh: response.checkoutUuid, pnr: query.pnrId, uuid: this.$route.query.uuid } });
            self.$store.commit("flight/updateCheckoutUuid", response.checkoutUuid);
         } else if (response.checkoutUuid) {
            self.$store.commit("flight/updateCheckoutUuid", response.checkoutUuid);
         }
         if (response.result.success) {
            self.isPageLoad = true;
         }

         //Buraya bakılcak
         if (response.completed) {
            self.paymentUuid = null;

            if (response.checkoutRequest.trxType == 2) {
               if (response.result.success) {
                  this.$router.push(`/order/detail/${response.reserveOrTicketResponse.orderUuid}?reserved=true`);
               } else {
                  this.$router.push(`/order/detail/${response.reserveOrTicketResponse.orderUuid}`);
               }
            } else if (response.checkoutRequest.trxType == 3 || response.checkoutRequest.trxType == 6) {
               this.$router.push(`/order/detail/${response.reserveOrTicketResponse.orderUuid}?issued=true`);
            } else {
               this.$router.push(`/order/detail/${response.reserveOrTicketResponse.orderUuid}`);
            }
         } else {
            // console.warn("FlightCheckout:: Error");
         }
      });
   },
   computed: {
      handlerPaymentTypes() {
         return this.$store.state.flight.checkout.response?.invalidPackage;
      },
      HasWarning() {
         return this.$store.state.flight.checkout.response?.warnings[-1];
      },
      handlerIsChange() {
         this.$store.state.flight.checkout.response.legs;
         return false;
      },
      warningsV2Filtered() {
         const warningsV2 = this.$store.state.flight.checkout.response?.warningsV2 || [];
         return warningsV2
            .filter((warning) => warning.type > 0)
            .map((warning) => {
               const warnTypeName = this.$options.filters.EFltWarnType(warning.type);
               const translatedPrefix = this.$t(warnTypeName);

               // Determine badge type based on warning type
               // 1: INFO -> info (blue)
               // 6: PRICE_UNAVAILABLE -> warning (yellow)
               // Others (2,3,4,5,7): CHANGE types -> error (red)
               let badgeType = "error"; // default
               if (warning.type === 1) {
                  badgeType = "info";
               } else if (warning.type === 6) {
                  badgeType = "warning";
               }

               return {
                  ...warning,
                  message: `${translatedPrefix} ${warning.message}`,
                  badgeType,
               };
            });
      },
   },
   methods: {
      handlerDocumentViewer(type) {
         this.$store.commit("app/setIsProgressGifActive", true);
         let checkoutUuid = this.$store.state.flight.checkout.request.checkoutUuid;
         this.$store.state.app.documentViewer.request.documentType = type;
         this.$store.state.app.documentViewer.request.identifiers = [{ identifier: checkoutUuid, subIdentifiers: [] }];
         this.$store.state.app.documentViewer.request.fileType = 2;
         this.$store.state.app.documentViewer.request.showPrice = false;
         this.$store.state.app.documentViewer.activeProductStatus = 0;
         this.$store.state.app.documentViewer.hasPrice = true;
         this.$store.commit("app/setDocumentViewer", true);
      },
      funcValidateForm() {
         return true;
      },
      handlerCookieData(passengers) {
         const self = this;
         const currentPaxCount = {};

         // Iterate over the passengers array and count the paxTypes
         for (const passenger of passengers) {
            const paxType = passenger.paxType;
            currentPaxCount[paxType] = (currentPaxCount[paxType] || 0) + 1;
         }
         if (getCookie("paxData")) {
            const paxData = JSON.parse(getCookie("paxData"));
            let paxDataCount = {};
            for (const passenger of paxData) {
               const paxType = passenger.paxType;
               paxDataCount[paxType] = (paxDataCount[paxType] || 0) + 1;
            }

            if (JSON.stringify(currentPaxCount) == JSON.stringify(paxDataCount) && paxData) {
               self.$store.commit("flight/setPaxCookieData", paxData);
            }
         }
         setCookie("paxCounts", JSON.stringify(currentPaxCount), 0, 1);
      },
   },
   watch: {
      "$store.state.flight.checkout": {
         handler: function (checkout) {
            this.checkoutRequestModel = checkout.request;
            this.checkoutRequestModel.uuid = this.$route.query.uuid;
            this.paymentChoiceDetail = checkout.response.paymentChoiceDetail;

            const legs = checkout.response.legs;
            // const warnings = checkout.response.warnings;
            // console.log(checkout.response.warningsV2);
            // this.brandPriceUnavailable = Object.keys(warnings).some((warning) => {
            //    return warnings[warning].includes("PRICE_UNAVAILABLE");
            // });

            const booleanArr = [];
            Object.keys(legs).forEach((leg) => {
               legs[leg].segments.forEach((segment) => {
                  booleanArr.push(segment.arrivalDateTimeChanged, segment.cabinTypeChanged, segment.departureDateTimeChanged, segment.flightClassChanged);
               });
            });
            this.isChanged = booleanArr.some((el) => {
               return el == true;
            });
         },
         deep: true,
      },
      brandPriceUnavailable: {
         handler: function (val) {
            if (val) {
               window.scrollTo({ top: 0, behavior: "smooth" });
            }
         },
      },
   },
};
</script>

<style lang="scss" scoped>
.checkout-badges {
   display: flex;
   flex-direction: column;
   gap: 0.5rem;
}

.send-offer-mobile {
   position: fixed;
   right: -2px;
   top: 50%;
   transform: translateY(-50%);
   background-color: var(--accent-primary);
   color: white;
   padding: 1.75rem 0.5rem;
   border-radius: 0.5rem;
   border-top-left-radius: 0;
   border-bottom-left-radius: 0;
   font-size: var(--normal);
   font-weight: 600;
   cursor: pointer;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
   z-index: 100;
   writing-mode: vertical-rl;
   text-orientation: mixed;
   transition: all 0.3s ease;
   transform: translateY(-50%) rotate(180deg);
   // opacity: 0.85;

   &:hover {
      background-color: var(--teal-300);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
   }

   &:active {
      transform: translateY(-50%) rotate(180deg) scale(0.95);
   }
}
</style>
